import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { ref, get } from "firebase/database";
import { db } from "../firebase";  // Assuming your firebase config exports 'db'

const Receipt = () => {
  const location = useLocation();
  const {
    stdName,
    stdFather,
    stdSurname,
    rollNo,
    serialNo,
    selectedClass,
    division,
    selectedYear,
    selectedRegisterNo,
  } = location.state || {};

  const [feeDetails, setFeeDetails] = useState({});
  const [schoolInfo, setSchoolInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [yearRange, setYearRange] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [feeData1, setFeeData1] = useState({});
  const language = localStorage.getItem("language");
  const [allFeeTypes, setAllFeeTypes] = useState([]);
  const [filteredFeeTypes, setFilteredFeeTypes] = useState([]);
  const [studentIdFees, setStudentIdFees] = useState(null); // New state for idFees
  const [studentHostelFees, setStudentHostelFees] = useState(null); // New state for idFees
  const [studentPendingFees, setStudentPendingFees] = useState(null); // New state for idFees
  const [prevYearRemainingFee, setPrevYearRemainingFee] = useState(null); // State for actual remaining fee of prev year
  const [isFreshStudent, setIsFreshStudent] = useState(false);
  const [currentYearPendingFeePaid, setCurrentYearPendingFeePaid] = useState(0);
  const navigate = useNavigate();

  const getBaseFeetype = (feetype) => {
    const lastIndex = feetype.lastIndexOf('-');
    return lastIndex !== -1 ? feetype.substring(0, lastIndex) : feetype;
  };

  const formatDate = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) {
      return "-";
    }
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${selectedYear}/${serialNo}.json`;
        const schoolUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`;

        const feeResponse = await fetch(feeUrl);
        const schoolResponse = await fetch(schoolUrl);

        if (feeResponse.ok && schoolResponse.ok) {
          const feeData = await feeResponse.json();
          const schoolData = await schoolResponse.json();

          if (feeData) {
            let maxPendingPaid = 0;
            const invoiceDetails = {};
            const years = [];
            let amountTotal = 0;
            let discountAmountTotal = 0;

            const invoiceNumbers = Object.keys(feeData);
            const lastInvoiceNo = invoiceNumbers[invoiceNumbers.length - 1];

            for (const [invoiceNumber, fees] of Object.entries(feeData)) {
              if (fees && typeof fees === "object") {
                const feeArray = [];
                for (const [feetype, feeDetails] of Object.entries(fees)) {
                  feeArray.push({ feetype, ...feeDetails });

                  if (feetype.toLowerCase().includes("pending fee")) {
                    const totalPaidSoFar = parseFloat(feeDetails.beforePay || 0) + parseFloat(feeDetails.payAmount || 0);
                    if (totalPaidSoFar > maxPendingPaid) {
                      maxPendingPaid = totalPaidSoFar;
                    }
                  }

                  if (invoiceNumber === lastInvoiceNo) {
                    amountTotal += parseFloat(feeDetails.amount || 0);
                    discountAmountTotal += parseFloat(
                      feeDetails.discountAmount || 0
                    );
                  }
                }
                invoiceDetails[invoiceNumber] = feeArray;

                feeArray.forEach((fee) => {
                  if (fee.year) {
                    const yearParts = fee.year.split("-");
                    if (yearParts.length === 2) {
                      const startYear = parseInt(yearParts[0], 10);
                      const endYear = parseInt(yearParts[1], 10);
                      years.push({ startYear, endYear });
                    }
                  }
                });
              }
            }

            setCurrentYearPendingFeePaid(maxPendingPaid);
            setFeeDetails(invoiceDetails);
            setTotalAmount(amountTotal);
            setTotalDiscountAmount(discountAmountTotal);

            if (years.length > 0) {
              const maxYearRange = years.reduce(
                (acc, year) => {
                  if (year.startYear > acc.startYear) {
                    return year;
                  } else if (
                    year.startYear === acc.startYear &&
                    year.endYear > acc.endYear
                  ) {
                    return year;
                  }
                  return acc;
                },
                { startYear: -Infinity, endYear: -Infinity }
              );

              setYearRange(`${maxYearRange.startYear}-${maxYearRange.endYear}`);
            }
          } else {
            setFeeDetails({});
          }

          if (schoolData) {
            setSchoolInfo(schoolData);
          } else {
            setSchoolInfo({});
          }
        } else {
          setFeeDetails({});
          setSchoolInfo({});
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setFeeDetails({});
        setSchoolInfo({});
      } finally {
        setLoading(false);
      }
    };

    if (selectedRegisterNo) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [selectedRegisterNo, selectedYear, serialNo, udiseNumber]);

  const fetchFeeTypes = async () => {
    const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${selectedYear}.json`;

    try {
      const response = await fetch(feeUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch fee types");
      }

      const feeData1 = await response.json();
      setFeeData1(feeData1);

      const feeTypesArray = feeData1 ? Object.keys(feeData1) : [];
      setAllFeeTypes(feeTypesArray);
      setFilteredFeeTypes(feeTypesArray); // Initially set filtered fee types to all
    } catch (error) {
      console.error("Error fetching fee types:", error);
    }
  };

  useEffect(() => {
    fetchFeeTypes();
  }, [selectedYear, udiseNumber]);

  // Fetch student ID Fees from Firebase SDK
  useEffect(() => {
    const fetchIdFees = async () => {
      if (!serialNo) return;
      try {
        const idFeesRef = ref(db, `schoolRegister/${udiseNumber}/IdFees/${selectedYear}/${serialNo}`);
        // console.log("idFeesRef",idFeesRef);

        const snapshot = await get(idFeesRef);
        // console.log("snapshot",snapshot);

        if (snapshot.exists()) {
          const idFeeAmount = snapshot.val();
          // console.log("idFeeAmount",idFeeAmount);

          setStudentIdFees(parseFloat(idFeeAmount) || 0);
        } else {
          setStudentIdFees(0);
        }
      } catch (error) {
        console.error("Error fetching ID fees:", error);
        setStudentIdFees(0);
      }
    };
    fetchIdFees();
  }, [serialNo]);

  useEffect(() => {
    const fetchHostelFees = async () => {
      if (!serialNo) return;
      try {
        const HostelFeesRef = ref(db, `schoolRegister/${udiseNumber}/hostel/${selectedYear}/${serialNo}`);
        // console.log("Hostel",HostelFeesRef);

        const snapshot = await get(HostelFeesRef);
        // console.log("snapshot",snapshot);

        if (snapshot.exists()) {
          const HostelFeeAmount = snapshot.val();
          // console.log("Hostel",HostelFeeAmount);

          setStudentHostelFees(parseFloat(HostelFeeAmount) || 0);
        } else {
          setStudentHostelFees(0);
        }
      } catch (error) {
        console.error("Error fetching ID fees:", error);
        setStudentHostelFees(0);
      }
    };
    fetchHostelFees();
  }, [serialNo]);


  useEffect(() => {
    const fetchPendingFees = async () => {
      if (!serialNo) return;
      try {
        const PendingFeesRef = ref(db, `schoolRegister/${udiseNumber}/pendingFee/${selectedYear}/${serialNo}`);
        // console.log("PendingFeesRef",PendingFeesRef);

        const snapshot = await get(PendingFeesRef);
        // console.log("snapshot",snapshot);

        if (snapshot.exists()) {
          const PendingFeeAmount = snapshot.val();
          // console.log("Pending",PendingFeeAmount);

          setStudentPendingFees(parseFloat(PendingFeeAmount) || 0);
        } else {
          setStudentPendingFees(0);
        }
      } catch (error) {
        console.error("Error fetching ID fees:", error);
        setStudentPendingFees(0);
      }
    };
    fetchPendingFees();
  }, [serialNo]);

  const getPreviousYear = (currentYear) => {
    if (!currentYear) return "";
    const parts = currentYear.split("-");
    if (parts.length === 2) {
      const start = parseInt(parts[0], 10);
      const end = parseInt(parts[1], 10);
      if (!isNaN(start) && !isNaN(end)) {
        return `${start - 1}-${end - 1}`;
      }
    }
    return "";
  };

  const prevYear = getPreviousYear(selectedYear) || getPreviousYear(yearRange);

  useEffect(() => {
    const fetchPrevYearFees = async () => {
      const pYear = getPreviousYear(selectedYear) || getPreviousYear(yearRange);
      if (!pYear || !serialNo) return;

      try {
        const studentFeeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${pYear}/${serialNo}.json`;
        const feesConfigUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${pYear}.json`;
        const idFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/IdFees/${pYear}/${serialNo}.json`;
        const hostelFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/hostel/${pYear}/${serialNo}.json`;
        const pendingFeesUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/pendingFee/${pYear}/${serialNo}.json`;
        const studentProfileUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${serialNo}.json`;

        const [studentFeeRes, feesConfigRes, idFeesRes, hostelFeesRes, pendingFeesRes, studentProfileRes] = await Promise.all([
          fetch(studentFeeUrl),
          fetch(feesConfigUrl),
          fetch(idFeesUrl),
          fetch(hostelFeesUrl),
          fetch(pendingFeesUrl),
          fetch(studentProfileUrl)
        ]);

        const studentFeeData = studentFeeRes.ok ? await studentFeeRes.json() : null;
        const feesConfigData = feesConfigRes.ok ? await feesConfigRes.json() : null;
        const studentProfile = studentProfileRes.ok ? await studentProfileRes.json() : null;

        let fresh = false;
        if (studentProfile && studentProfile.dateOfAdmission) {
          const getAcademicYearFromDate = (dateStr) => {
            if (!dateStr) return "";
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return "";
            const yearVal = date.getFullYear();
            const monthVal = date.getMonth(); // 0-indexed (0 is Jan, 3 is Apr)
            if (monthVal >= 3) { // April to December
              return `${yearVal}-${yearVal + 1}`;
            } else { // January to March
              return `${yearVal - 1}-${yearVal}`;
            }
          };
          const admissionYear = getAcademicYearFromDate(studentProfile.dateOfAdmission);
          if (admissionYear) {
            const pStartYear = parseInt(pYear.split('-')[0], 10);
            const admStartYear = parseInt(admissionYear.split('-')[0], 10);
            if (!isNaN(pStartYear) && !isNaN(admStartYear) && pStartYear < admStartYear) {
              fresh = true;
            }
          }
        }
        setIsFreshStudent(fresh);

        if (fresh) {
          setPrevYearRemainingFee(0);
          return;
        }
        const idFeeAmt = idFeesRes.ok ? parseFloat(await idFeesRes.json()) || 0 : 0;
        const hostelFeeAmt = hostelFeesRes.ok ? parseFloat(await hostelFeesRes.json()) || 0 : 0;
        const pendingFeeAmt = pendingFeesRes.ok ? parseFloat(await pendingFeesRes.json()) || 0 : 0;

        let totalFee = 0;
        let totalDiscount = 0;
        let totalPaid = 0;

        const grouped = {};
        const lastDiscountAmounts = {};
        const lastBeforePay = {};

        // Determine previous year's class from invoices first
        let prevYearClass = selectedClass;
        if (studentFeeData && typeof studentFeeData === "object") {
          for (const [invoiceNumber, fees] of Object.entries(studentFeeData)) {
            if (fees && typeof fees === "object") {
              for (const [feetype, feeDetails] of Object.entries(fees)) {
                if (feeDetails && feeDetails.class) {
                  prevYearClass = feeDetails.class;
                  break;
                }
              }
            }
            if (prevYearClass !== selectedClass) break;
          }
        }

        const isFeeTypeValid = (feetype, feesConfigData, prevYearClass) => {
          const lowerFee = feetype.toLowerCase();
          if (
            lowerFee.includes("identity card fee") ||
            lowerFee.includes("hostel fee") ||
            lowerFee.includes("pending fee") ||
            lowerFee.includes("bus fee")
          ) {
            return true;
          }

          if (feesConfigData && typeof feesConfigData === "object") {
            for (const [configFeeType, feeDetails] of Object.entries(feesConfigData)) {
              if (
                configFeeType.toLowerCase() === feetype.toLowerCase() &&
                feeDetails &&
                (feeDetails.classType === prevYearClass || feeDetails.classType === "All")
              ) {
                return true;
              }
            }
            // If class config is present but this fee type is not in it, consider it deleted
            return false;
          }
          // If class config is missing entirely, fallback to valid to prevent breaking
          return true;
        };

        // 1. Process studentFeeData (invoices)
        if (studentFeeData && typeof studentFeeData === "object") {
          for (const [invoiceNumber, fees] of Object.entries(studentFeeData)) {
            if (fees && typeof fees === "object") {
              for (const [feetype, feeDetails] of Object.entries(fees)) {
                if (feeDetails && isFeeTypeValid(feetype, feesConfigData, prevYearClass)) {
                  const amount = parseFloat(feeDetails.amount || 0);
                  const discount = parseFloat(feeDetails.discountAmount || 0);
                  const beforePay = parseFloat(feeDetails.beforePay || 0);

                  grouped[feetype] = amount;
                  lastDiscountAmounts[feetype] = discount;
                  lastBeforePay[feetype] = beforePay;
                }
              }
            }
          }
        }

        // Add fee types from invoices to totals
        for (const feetype in grouped) {
          totalFee += grouped[feetype];
          totalDiscount += lastDiscountAmounts[feetype] || 0;
          totalPaid += lastBeforePay[feetype] || 0;
        }

        // 2. Process class-configured fees that are NOT in student invoices
        if (feesConfigData && typeof feesConfigData === "object") {
          for (const [feeType, feeDetails] of Object.entries(feesConfigData)) {
            if (feeDetails && (feeDetails.classType === prevYearClass || feeDetails.classType === "All")) {
              if (grouped[feeType] === undefined) {
                const amount = parseFloat(feeDetails.amount || 0);
                totalFee += amount;
              }
            }
          }
        }

        // 3. Process additional fees
        const feeExistsInGrouped = (feeName) => {
          return Object.keys(grouped).some(ft => ft.toLowerCase().includes(feeName.toLowerCase()));
        };

        if (idFeeAmt > 0 && !feeExistsInGrouped("Identity Card Fee")) {
          totalFee += idFeeAmt;
        }
        if (hostelFeeAmt > 0 && !feeExistsInGrouped("Hostel Fee")) {
          totalFee += hostelFeeAmt;
        }
        if (pendingFeeAmt > 0 && !feeExistsInGrouped("Pending Fee")) {
          totalFee += pendingFeeAmt;
        }

        const remaining = totalFee - totalDiscount - totalPaid;
        setPrevYearRemainingFee(remaining > 0 ? remaining : 0);
      } catch (error) {
        console.error("Error calculating previous year remaining fee:", error);
      }
    };

    fetchPrevYearFees();
  }, [serialNo, selectedYear, yearRange, selectedClass, udiseNumber]);

  const rawPendingFee = isFreshStudent
    ? (studentPendingFees || 0)
    : (prevYearRemainingFee !== null ? prevYearRemainingFee : (studentPendingFees || 0));



  // Function to group fee details

  const groupedFees = () => {
    const grouped = {};
    let totalIncludedAmount = 0; // Variable to hold total amount from included fee types
    const lastDiscountAmounts = {}; // Object to hold the last discount amount for each fee type

    // Check if feeDetails is defined and is an object
    if (feeDetails && typeof feeDetails === 'object') {
      // Group existing fee details by invoice
      Object.entries(feeDetails).forEach(([invNo, fees]) => {
        fees.forEach((fee) => {
          if (!grouped[fee.feetype]) {
            grouped[fee.feetype] = [];
          }
          grouped[fee.feetype].push({
            invoiceNo: invNo,
            amount: parseFloat(fee.amount || "0"),
            remainingAmount: parseFloat(fee.remainingAmount || "0"),
            discountAmount: parseFloat(fee.discountAmount || "0"),
            date: fee.date || "0",
            beforePay: parseFloat(fee.beforePay || "0"),
          });

          lastDiscountAmounts[fee.feetype] = parseFloat(fee.discountAmount || "0");
        });
      });

      // Sort grouped fees by date to ensure correct order for calculation
      Object.keys(grouped).forEach((feetype) => {
        grouped[feetype].sort((a, b) => new Date(a.date) - new Date(b.date));
      });
    }

    // Include fee types from feeData1 that match the selected class or are "ALL"
    const allFeeTypes = Object.keys(feeData1 || {}); // Ensure feeData1 is defined
    allFeeTypes.forEach((feeType) => {
      const feeDetails = feeData1[feeType];

      // Check if the class matches or if the class type is "ALL"
      if (
        !grouped[feeType] &&
        (feeDetails.classType === selectedClass ||
          feeDetails.classType === "All")
      ) {
        const amount = parseFloat(feeDetails.amount || "0");
        grouped[feeType] = [
          {
            invoiceNo: "-", // No invoice number
            amount: amount, // Default amount from feeData1
            remainingAmount: amount, // Assuming initial remaining amount equals the fee amount
            discountAmount: lastDiscountAmounts[feeType] || 0, // Use last discount amount
            date: " ", // No date
            beforePay: 0, // No before pay
          },
        ];
        // Add to the total included amount
        totalIncludedAmount += amount;
      }
    });

    return { grouped, totalIncludedAmount, lastDiscountAmounts }; // Return both grouped fees and total amount
  };

  // In your Receipt component, update how you call groupedFees
  const {
    grouped: feeData,
    totalIncludedAmount,
    lastDiscountAmounts,
  } = groupedFees();

  const displayPendingFee = Math.max(0, rawPendingFee - currentYearPendingFeePaid);

  const printRef = useRef();

  const handlePrint = () => {
    const printContent = printRef.current;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
        <html>
          <head>
            <title>Print Receipt</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                -webkit-print-color-adjust: exact;
                margin: 0;
                padding: 15px;
                border: 1px solid black;
              }
              @page {
                size: A4 Portrait;
                margin: 3mm; /* this affects the margin in the printer settings */
              }
              .conner {
                max-width: 600px;
                height: auto;
                background-color: white;
                padding: 10px;
                border : 1px solid black !important;
              }
              .receipt-header {
                border: 1px solid black;
                background-color: #F7F7F7;
                padding: 10px;
                text-align: center;
              }
              .receipt-header h4, .rec-sanstaname {
                margin: 0;
                margin-bottom: 10px;
              }
              .receipt-header h5 {
                display: block;
                border: 1px solid black;
                background-color: black;
                color: white;
                padding: 5px;
                width: 180px;
                text-align: center;
                margin: 10px auto;
                border-radius: 10px;
              }
              .card {
                padding: 20px;
              }
              .row {
                display: flex;
                justify-content: space-between;
                margin-bottom: -30px;
              }
              .col-md-4 {
                flex: 1;
                padding: 5px;
              }
              .col-md-4 p {
                font-size: 14px;
                color: #333;
              }
              .col-md-4 p strong {
                color: black;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 20px;
              }
              th, td {
                border: 1px solid black;
                padding: 10px;
                text-align: center;
                font-size: 13px;
              }
              th {
                background-color: gray;
                color: white;
                font-size: 14px;
              }
              tr:hover {
                background-color: #e0e0e0;
              }
              .footer {
                margin-top: 20px;
                text-align: center;
                font-size: 0.9rem;
                color: #666;
              }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            ${printContent.innerHTML}
          </body>
        </html>
      `);
    printWindow.document.close();
  };

  const handleGoBack = () => {
    navigate(-1); // Use navigate to go back
  };

  const feeExists = (feeType) => {
    return Object.values(feeDetails).some(fees =>
      fees.some(fee => fee.feetype === feeType)
    );
  };

  return (
    <div className="main-content-of-page mb-5" >
      <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
        <button
          onClick={handleGoBack}
          style={{
            backgroundColor: '#FFFFFF',
            color: 'black',
            padding: '7px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '20px', // Space between buttons
            border: '1px solid black',
            marginTop: '20px',
            marginLeft: '30px',
          }}
        >
          <i className="fa fa-arrow-left" style={{ fontSize: '24px', marginRight: '8px' }}></i>
          Go Back
        </button>
        <button
          onClick={handlePrint}
          style={{
            backgroundColor: '#6495ED', /* Green background color */
            color: 'white', /* White text color */
            padding: '10px 20px', /* Add some padding to make the button larger */
            border: 'none', /* Remove the default border */
            borderRadius: '5px', /* Add a rounded corner effect */
            cursor: 'pointer',/* Change the cursor to a pointing hand when hovered */
            marginLeft: '10px',
            marginTop: '20px'
          }}
        >
          Print Report
        </button>
      </div>
      <div
        className="conner my-4 p-4"
        ref={printRef}
        style={{
          maxWidth: "250mm", /* Set the maximum width to 290mm */
          width: "auto", /* A4 width */
          height: "auto", /* A4 height */
          margin: '0 auto', /* center the container */
          boxShadow: '0 0 8px 5px rgba(0, 0, 0, 0.3)',
          boxSizing: 'border-box', /* include padding and border in the width and height */
          padding: '3mm', /* add some padding to make it look better */
          border: '1px solid #0e0303', /* add a border to make it look like a page */
          overflow: 'hidden', /* hide any content that exceeds the container size */
        }}
      >
        {loading ? (
          <p className="text-center text-secondary">Loading...</p>
        ) : (
          <div>
            <div
              className="receipt-header"
              style={{
                border: "1px solid black",
                backgroundColor: "#F7F7F7",
                padding: "10px",
              }}
            >
              <p className="rec-sanstaname">{schoolInfo.sansthaName || ""}</p>
              <h4>{schoolInfo.schoolName || ""}</h4>
              <div className="taludis" style={{ textAlign: "center" }}>
                <p className="rec-sanstaname">
                  Taluka: {schoolInfo.taluka}, District: {schoolInfo.jilha}
                </p>
              </div>

              <h5
                style={{
                  display: "block",
                  border: "1px solid black",
                  backgroundColor: "black",
                  color: "white",
                  padding: "5px",
                  width: "150px",
                  textAlign: "center",
                  margin: "0 auto",
                  borderRadius: "5px",
                }}
              >
                Fee Receipt
              </h5>
            </div>

            <div className="card px-4 py-3" style={{ marginTop: "-20px" }}>
              <div className="row">
                <div className="col-md-4">
                  <p style={{ fontSize: "15px", color: "#333" }}>
                    <strong style={{ color: "black" }}>
                      {language === "English" ? "Name : " : "नाव : "}
                    </strong>{" "}
                    {stdName} {stdFather} {stdSurname}
                  </p>
                </div>
                <div className="col-md-4">
                  <p style={{ fontSize: "15px", color: "#333" }}>
                    <strong style={{ color: "black" }}>
                      {language === "English" ? "Class:" : "वर्ग:"}
                    </strong>{" "}
                    {selectedClass}
                  </p>
                </div>
                <div className="col-md-4">
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#333",
                      textAlign: "left",
                    }}
                  >
                    <strong style={{ color: "black" }}>
                      {language === "English" ? "Division:" : "तुकडी:"}
                    </strong>{" "}
                    {division}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#333",
                      textAlign: "left",
                    }}
                  >
                    <strong style={{ color: "black" }}>
                      {language === "English"
                        ? "Register No:"
                        : "रजिस्टर क्र.:"}
                    </strong>{" "}
                    {selectedRegisterNo}
                  </p>
                </div>
                <div className="col-md-4">
                  <p
                    style={{
                      fontSize: "15px",
                      color: "#333",
                      textAlign: "left",
                    }}
                  >
                    <strong style={{ color: "black" }}>
                      {language === "English" ? "Year:" : "वर्ष:"}
                    </strong>{" "}
                    {yearRange}
                  </p>
                </div>
                <div className="col-md-4">
                  {displayPendingFee > 0 && (
                    <p
                      style={{
                        fontSize: "15px",
                        color: "#333",
                        textAlign: "left",
                      }}
                    >
                      <strong style={{ color: "black" }}>
                        {language === "English"
                          ? `Pending Fee (${prevYear}):`
                          : `मागील वर्षाची शिल्लक फी (${prevYear}):`}
                      </strong>{" "}
                      ₹{displayPendingFee.toFixed(2)}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <table className="text-center">
              <thead
                style={{
                  fontWeight: "bold",
                  color: "black",
                  backgroundColor: "#6495ed",
                }}
              >
                <tr>
                  <th style={{ backgroundColor: '#6495ED', fontWeight: 'bold' }}>{language === "English" ? "Fee Type" : "फी प्रकार"}</th>
                  <th style={{ backgroundColor: '#6495ED', fontWeight: 'bold' }}>
                    {language === "English" ? "Invoice No" : "पावती नंबर"}
                  </th>
                  <th style={{ backgroundColor: '#6495ED', fontWeight: 'bold' }}>{language === "English" ? " Total Fee" : "एकूण फी"}</th>
                  <th style={{ width: "80px", backgroundColor: '#6495ED', fontWeight: 'bold' }}>
                    {language === "English" ? "Discount Rs" : "सवलत रक्कम"}
                  </th>
                  <th style={{ backgroundColor: '#6495ED', fontWeight: 'bold' }}>
                    {language === "English"
                      ? "amount to be paid"
                      : "भरण्याची रक्कम"}
                  </th>
                  <th style={{ width: "150px", backgroundColor: '#6495ED', fontWeight: 'bold' }}>
                    {language === "English" ? "Date" : "दिनांक"}
                  </th>
                  <th style={{ backgroundColor: '#6495ED', fontWeight: 'bold' }}>{language === "English" ? "Paid Fee" : "दिलेली फी"}</th>
                  <th style={{ backgroundColor: '#6495ED', fontWeight: 'bold' }}>{language === "English" ? "Balance" : "शिल्लक"}</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  const previousBeforePay = {};
                  const totalBeforePay = {};
                  let totalDisplayedRemainingFee = 0;
                  let totalRemainingBalance = 0;
                  let totalPaidFee = 0;
                  let totalFeeAmount = 0;

                  const rows = Object.entries(feeData).map(([feetype, feeEntries]) => {
                    totalBeforePay[feetype] = 0;
                    let firstRow = true;
                    let feeTypeAmount = 0;

                    // Filter out fee entries with null, empty, or 0 amount
                    const validFeeEntries = feeEntries.filter(({ amount }) => amount && parseFloat(amount) > 0);

                    validFeeEntries.forEach(({ amount }) => {
                      feeTypeAmount = parseFloat(amount) || 0;
                    });

                    // Add feeTypeAmount to totalAmount
                    totalFeeAmount += feeTypeAmount;

                    // Only render if there are valid fee entries
                    if (validFeeEntries.length > 0) {
                      const feeRows = validFeeEntries.map(
                        ({ invoiceNo, amount, date, beforePay }, index) => {
                          let beforePayDisplay = beforePay;
                          if (previousBeforePay[feetype] !== undefined) {
                            beforePayDisplay -= previousBeforePay[feetype];
                          }

                          previousBeforePay[feetype] = beforePay;
                          totalBeforePay[feetype] += beforePayDisplay;

                          const displayedRemainingFee =
                            validFeeEntries.length > 0
                              ? amount - lastDiscountAmounts[feetype] - beforePay
                              : "0.00";

                          // Accumulate the displayed remaining fee
                          if (index === validFeeEntries.length - 1) {
                            totalDisplayedRemainingFee += parseFloat(displayedRemainingFee) || 0;
                          }
                          if (invoiceNo === "-") {
                            totalRemainingBalance += parseFloat(amount) || 0;
                          }
                          // Add paid fee
                          totalPaidFee += parseFloat(beforePayDisplay) || 0;

                          console.log("amount - lastDiscountAmounts[feetype]", amount - lastDiscountAmounts[feetype])

                          console.log("lastDiscountAmounts[feetype]", lastDiscountAmounts[feetype])

                          const amounttobepaid = isNaN(amount - lastDiscountAmounts[feetype]) ? amount.toFixed(2) : (amount - lastDiscountAmounts[feetype]).toFixed(2)
                          {/* console.log("amounttobepaid",amounttobepaid) */ }

                          const balance = isNaN(displayedRemainingFee) ? (amount - (lastDiscountAmounts[feetype] || 0)).toFixed(2) : displayedRemainingFee.toFixed(2);

                          return (
                            <tr key={`${feetype}-${invoiceNo}-${index}`}>
                              {firstRow && (
                                <td
                                  rowSpan={validFeeEntries.length}
                                  style={{ verticalAlign: "middle" }}
                                >
                                  {getBaseFeetype(feetype)}
                                </td>
                              )}
                              <td>{invoiceNo}</td>
                              <td>{amount.toFixed(2)}</td>
                              <td>{lastDiscountAmounts[feetype]}</td>
                              <td>{amounttobepaid}</td>
                              <td style={{ width: '150px', whiteSpace: 'nowrap' }}>{formatDate(date) || '-'}</td>
                              <td>{beforePayDisplay.toFixed(2) || 0}</td>
                              <td>{balance}</td>
                              {(firstRow = false)}
                            </tr>
                          );
                        }
                      );

                      feeRows.push(
                        <tr key={`total-${feetype}`} className="font-weight-bold bg-light">
                          <td
                            colSpan={6}
                            style={{
                              backgroundColor: "#e3e6e970",
                              textAlign: "right",
                              fontWeight: "600",
                            }}
                          >
                            {language === "English"
                              ? `Total ${getBaseFeetype(feetype)}`
                              : `एकूण ${getBaseFeetype(feetype)}`}{" "}
                            :
                          </td>
                          <td style={{ fontWeight: "600" }}>
                            {totalBeforePay[feetype].toFixed(2) || 0}
                          </td>
                          <td style={{ fontWeight: "600" }}>
                            {validFeeEntries.length > 0
                              ? (
                                validFeeEntries[validFeeEntries.length - 1].amount -
                                (lastDiscountAmounts[feetype] || 0) -
                                totalBeforePay[feetype]
                              ).toFixed(2)
                              : "0.00"}
                          </td>
                        </tr>
                      );

                      return feeRows;
                    }
                    return null;
                  });

                  // Add a new row for ID Fees if available
                  if (studentIdFees !== null && !feeExists("Identity Card Fee") && studentIdFees > 0) {
                    rows.push(
                      <tr key="id-fees" className="font-weight-bold">
                        <td >Identity Card Fee</td>
                        <td>-</td>
                        <td>{studentIdFees.toFixed(2)}</td>
                        <td> </td>
                        <td>{studentIdFees.toFixed(2)}</td>
                        <td>-</td>
                        <td>0.00</td>
                        <td>{studentIdFees.toFixed(2)}</td>
                      </tr>
                    );

                    rows.push(
                      <tr key="total-id-fees" className="font-weight-bold bg-light">
                        <td colSpan={6} style={{ backgroundColor: "#e3e6e970", textAlign: "right", fontWeight: "600" }}>
                          {language === "English"
                            ? `Total Identity Card Fee`
                            : `एकूण Identity Card Fee`} :
                        </td>
                        <td style={{ fontWeight: "600" }}>
                          0.00
                        </td>
                        <td style={{ fontWeight: "600" }}>
                          {studentIdFees.toFixed(2)}
                        </td>
                      </tr>
                    );

                    totalFeeAmount += studentIdFees;

                  }

                  // Add a new row for Hostel Fees if available
                  if (studentHostelFees !== null && !feeExists("Hostel Fee") && studentHostelFees > 0) {
                    rows.push(
                      <tr key="Hostel-fees" className="font-weight-bold" >
                        <td>Hostel Fee</td>
                        <td>-</td>
                        <td>{studentHostelFees.toFixed(2)}</td>
                        <td>0 </td>
                        <td>{studentHostelFees.toFixed(2)}</td>
                        <td>-</td>
                        <td>0.00</td>
                        <td>{studentHostelFees.toFixed(2)}</td>
                      </tr>
                    );
                    rows.push(
                      <tr key="total-Hostel-fees" className="font-weight-bold bg-light">
                        <td colSpan={6} style={{ backgroundColor: "#e3e6e970", textAlign: "right", fontWeight: "600" }}>
                          {language === "English"
                            ? `Total Hostel Fee`
                            : `एकूण Hostel Fee`} :
                        </td>
                        <td style={{ fontWeight: "600" }}>
                          0.00
                        </td>
                        <td style={{ fontWeight: "600" }}>
                          {studentHostelFees.toFixed(2)}
                        </td>
                      </tr>
                    );
                    totalFeeAmount += studentHostelFees;

                  }


                  // Add a new row for Pending Fees if available
                  if (studentPendingFees !== null && !feeExists("Pending Fee") && studentPendingFees > 0) {
                    rows.push(
                      <tr key="Pending-fees" className="font-weight-bold" >
                        <td style={{ verticalAlign: "middle" }}>Pending Fee</td>
                        <td>-</td>
                        <td>{studentPendingFees.toFixed(2)}</td>
                        <td>0 </td>
                        <td>{studentPendingFees.toFixed(2)}</td>
                        <td>-</td>
                        <td>0.00</td>
                        <td>{studentPendingFees.toFixed(2)}</td>
                      </tr>
                    );
                    rows.push(
                      <tr key="total-pending-fees" className="font-weight-bold bg-light">
                        <td colSpan={6} style={{ backgroundColor: "#e3e6e970", textAlign: "right", fontWeight: "600" }}>
                          {language === "English"
                            ? `Total Pending Fee`
                            : `एकूण Pending Fee`}  :
                        </td>
                        <td style={{ fontWeight: "600" }}>
                          0.00
                        </td>
                        <td style={{ fontWeight: "600" }}>
                          {studentPendingFees.toFixed(2)}
                        </td>
                      </tr>
                    );
                    totalFeeAmount += studentPendingFees;

                  }

                  // Add grand total row
                  rows.push(
                    <tr key="total-remaining-fee" className="font-weight-bold bg-light py-3">
                      <td colSpan={2} style={{ backgroundColor: "#e9ecef", textAlign: "left", fontWeight: "600", paddingTop: "20px", paddingBottom: "20px" }}>
                        {language === "English" ? "Total Fee Amount :" : "फी एकूण रक्कम :"} ₹{totalFeeAmount.toFixed(2)}
                      </td>
                      <td colSpan={2} style={{ backgroundColor: "#e9ecef", textAlign: "left", fontWeight: "600", paddingTop: "20px", paddingBottom: "20px" }}>
                        {language === "English" ? "Discount Amount:" : "सवलत रक्कम:"} ₹{totalDiscountAmount.toFixed(2)}
                      </td>
                      <td colSpan={2} style={{ backgroundColor: "#e9ecef", textAlign: "left", fontWeight: "600", paddingTop: "20px", paddingBottom: "20px" }}>
                        {language === "English" ? "Total Paid Fee : " : "एकूण दिलेली फी : "} ₹{totalPaidFee.toFixed(2)}
                      </td>
                      <td colSpan={2} style={{ backgroundColor: "#e9ecef", textAlign: "left", fontWeight: "600", paddingTop: "20px", paddingBottom: "20px" }}>
                        {language === "English" ? "Total balance fee : " : "एकूण शिल्लक फी  : "} ₹{(totalFeeAmount - totalDiscountAmount - totalPaidFee).toFixed(2)}
                      </td>
                    </tr>
                  );

                  return rows;
                })()}
              </tbody>
            </table>

          </div>
        )}
      </div>
    </div>
  );
};

export default Receipt;

